import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark, faUsers, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';

const QuestionsProgress = ({ 
  currentIndex, 
  totalQuestions, 
  isBookmarked, 
  communityStats,
  onBookmark,
  onShowCommunity,
  theme,
  hideBookmark = false
}) => {
  const styles = {
    container: {
      marginBottom: '1.5rem',
      display: 'flex',
      justifyContent: 'flex-start', // changed from flex-end
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between', // changed from flex-start
      alignItems: 'center',
      width: '100%', // ensure it stretches
    },
    questionInfo: {
      fontSize: '1.25rem',
      fontWeight: '700',
      color: theme?.primary?.blue?.[600] || '#0891b2',
      marginLeft: '1rem',
    },
    actions: {
      display: 'flex',
      gap: '1rem',
      alignItems: 'center',
      marginRight: '1rem',
    },
    actionButton: {
      width: '2.5rem',
      height: '2.5rem',
      borderRadius: '0.75rem',
      border: `1px solid ${theme?.borders?.primary}`,
      background: theme?.backgrounds?.secondary,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
    communityButton: {
      cursor: 'pointer',
      transition: 'all 0.3s ease',
    },
  };
  

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.questionInfo}>Question {currentIndex + 1} of {totalQuestions}</h2>
        <div style={styles.actions}>
          {communityStats && (
            <motion.div
              style={styles.communityButton}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
              onClick={onShowCommunity}
            >
              <FontAwesomeIcon 
                icon={faUsers}
                size="lg"
                style={{ color: communityStats.color }}
              />
            </motion.div>
          )}
          
          {!hideBookmark && (
            <motion.button
              style={styles.actionButton}
              whileHover={{ 
                scale: 1.05,
                background: theme?.primary?.indigo?.[100] || '#e0e7ff',
              }}
              whileTap={{ scale: 0.95 }}
              onClick={onBookmark}
            >
              <FontAwesomeIcon 
                icon={isBookmarked ? faBookmark : faBookmarkRegular}
                style={{ 
                  color: isBookmarked 
                    ? theme?.primary?.yellow?.[600]
                    : theme?.primary?.gray?.[500] 
                }}
              />
            </motion.button>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestionsProgress;